export default __webpack_public_path__ + "static/media/05_07.9983813a.jpg";